import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  bulkUpsertStudents,
  bulkDeleteStudents,
  BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE,
  BULK_DELETE_STUDENTS_SUCCESS_MESSAGE,
  studentsPath,
  fetchClasses,
  fetchStudents,
  fetchPlans,
  FETCH_STUDENTS_SUCCESS_MESSAGE,
  FETCH_CLASSES_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import StudentSpreadSheet from "../../../templates/manager/StudentSpreadSheet";
import { IStudentForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import Toast from "../../../molecules/Toast";

const BulkEditStudents = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [isSelectMode, setIsSelectMode] = React.useState(false);
  const [filterByClass, setFilterByClass] = React.useState("");
  const [filterByYear, setFilterByYear] = React.useState("");
  const [fetched, setFetched] = React.useState({
    students: false,
    classes: false,
  });
  const history = useHistory();
  const { currentYear } = useCurrentYear();

  React.useEffect(() => {
    if (state.success_message === BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(studentsPath);
    }
    if (state.success_message === BULK_DELETE_STUDENTS_SUCCESS_MESSAGE) {
      Toast.success(state.success_message);
      setIsSelectMode(false);
      dispatch(clearSuccessMessage());
    }
    if (state.success_message === FETCH_STUDENTS_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, students: true }));
      }, 100);
    }
    if (state.success_message === FETCH_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 100);
    }
  }, [history, dispatch, state.success_message]);

  const bulkUpsertStudentsFunc = React.useCallback(
    (students: IStudentForRegister[]) => {
      dispatch(peep(bulkUpsertStudents(students)));
    },
    [dispatch, peep],
  );

  const bulkDeleteStudentsFunc = React.useCallback(
    (student_ids: number[]) => {
      dispatch(peep(bulkDeleteStudents(student_ids)));
    },
    [dispatch, peep],
  );

  const refetchStudents = React.useCallback(() => {
    dispatch(peep(fetchClasses(currentYear)));
    dispatch(
      peep(
        fetchStudents(filterByClass, filterByYear, false, false, false, true),
      ),
    );
  }, [dispatch, peep, filterByClass, filterByYear, currentYear]);

  React.useEffect(() => {
    dispatch(fetchClasses(currentYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, currentYear]);

  React.useEffect(() => {
    dispatch(
      fetchStudents(filterByClass, filterByYear, false, false, false, true),
    );
  }, [filterByClass, filterByYear, dispatch]);

  React.useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  return (
    <div>
      <Breadcrumb
        links={[
          {
            title:
              state.manager.school?.use_case === "cram_school"
                ? titles.cramSchoolStudents
                : titles.students,
            to: studentsPath,
          },
        ]}
        currentTitle={titles.bulkEditStudents}
      />
      {fetched.classes && fetched.students && (
        <StudentSpreadSheet
          title={titles.bulkEditStudents}
          calling={calling}
          error={state.error}
          students={state.students}
          classes={state.classes}
          school={state.manager.school!}
          isNextYear={false}
          save={bulkUpsertStudentsFunc}
          deleteStudents={bulkDeleteStudentsFunc}
          failedStudentIds={state.bulk_delete_failed_ids}
          isSelectMode={isSelectMode}
          onChangeSelectMode={setIsSelectMode}
          reset={refetchStudents}
          onFilterByClass={setFilterByClass}
          onFilterByYear={setFilterByYear}
          plans={state.plans}
        />
      )}
    </div>
  );
};

export default BulkEditStudents;
